import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid, Stack, Divider, Box, Typography} from 'views/components';
import {Translate} from 'views/module';

import Filter from '../filter/Filter';
import InternalApplicationCard from './InternalApplicationCard';

import {generateFilterOptions} from '../filter/FilterGenerator';

const InternalApplications = (props) => {
  const {applications = [], jobBackend} = props;

  const filterOptions = generateFilterOptions();
  const internalApplications = React.useMemo(() => {
    return applications.filter((application) => application.source === 'INTERNAL');
  }, [applications]);

  const defaultSelection = () => {
    return {
      order: {orderBy: 'creationTime', orderDirc: 'DESC'},
      filter: {
        status: {
          filterData: filterOptions['status'],
          optionSelected: [
            'ACCEPTED',
            'PENDING',
          ],
        },
      },
    };
  };

  const [selection, setSelection] = React.useState(defaultSelection());

  const resetFilter = () => {
    setSelection(defaultSelection());
  };

  const updateFilter = (filter, option) => {
    setSelection((prev) => {
      const newFilter = {...prev.filter};

      if (option) {
        if (filter.multiSelect) {
          const selected = newFilter[filter.key]?.optionSelected || [];

          const doesItExist = selected.find((k) => k === option.key);
          if (!doesItExist) {
          // Add option
            newFilter[filter.key] = {
              filterData: filter,
              optionSelected: [...selected, option.key],
            };
          } else {
            // Remove option
            newFilter[filter.key] = {
              ...newFilter[filter.key],
              optionSelected: selected.filter((k) => k !== option.key),
            };
          }
        } else {
          // Single select: replace value
          newFilter[filter.key] = {
            filterData: filter,
            optionSelected: option.key,
          };
        }
      } else {
        // Remove filter entirely
        delete newFilter[filter.key];
      }

      return {...prev, filter: newFilter};
    });
  };

  const filteredApplications = React.useMemo(() => {
    return internalApplications.filter((application) => {
      const statusFilter = selection.filter.status;
      if (statusFilter) {
        const selectedStatus = statusFilter.optionSelected;
        return selectedStatus.find((e) => application.status === e);
      }
      return true;
    });
  }, [internalApplications, selection.filter]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Divider/>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} justifyContent='space-between' alignItems={{md: 'center'}}>
          <Grid item xs={12}>
            <Stack direction='row' >
              <Stack spacing={2} width={1}>
                <Stack spacing={2} >
                  <Box px={2} >
                    <Filter
                      selection={selection}
                      filterOptions={filterOptions}
                      updateFilter={updateFilter}
                      onClearFilter={resetFilter}
                    />
                  </Box>
                </Stack>
                <Stack>
                  <Box pb={1}>
                    {
                      filteredApplications.length === 0 &&
                      <Typography color="text.secondary" align="center">
                        <Translate expression="career.jobDetail.EmptyApplications" />
                      </Typography>
                    }
                    {
                      filteredApplications.length > 0 &&
                      filteredApplications.map((application) => (
                        <Box key={application.caregiverRn} px={2}>
                          <InternalApplicationCard
                            application={application}
                            jobBackend={jobBackend}
                          />
                        </Box>
                      ))
                    }
                  </Box>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

InternalApplications.propTypes = {
  applications: PropTypes.array.isRequired,
  jobBackend: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(InternalApplications));
